import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../withRouter";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";
import ChangePasswordModal from "../../ChangePasswordModal";
import callApi from "../../../helpers/CallApi";
import { changePassword } from "../../../helpers/API";
import { toast } from "react-toastify";

const ProfileMenu = (props) => {
  // Declare a new state variable, which we'll call "menu"
  const navigate = useNavigate();
  const [menu, setMenu] = useState(false);
  const [userPic, setUserPic] = useState("");
  const [username, setusername] = useState("");
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("user")) {
      const obj = JSON.parse(localStorage.getItem("user"));
      setusername(obj?.name);
      setUserPic(obj?.profile || "");
    }
  }, [props.success]);

  // Toggle modal
  const toggleChangePasswordModal = () => {
    setShowChangePasswordModal(!showChangePasswordModal);
  };

  // Handle password change
  const handlePasswordChange = async (payload) => {
    callApi({
      callback: changePassword,
      payload,
      onSuccess: () => {
        toggleChangePasswordModal();
        navigate("/logout");
      },
      onError: (message) => {
        console.log(message);

        toast.error(message);
      },
    });
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={userPic || user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-2">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag={Link} to="/userprofile">
            {" "}
            <i className="ri-user-line align-middle me-2" />
            {props.t("Profile")}{" "}
          </DropdownItem>

          <DropdownItem tag="button" onClick={toggleChangePasswordModal}>
            <i className="ri-settings-2-line align-middle me-2" />
            {props.t("Password Change")}
          </DropdownItem>
          <DropdownItem tag="a" href="auth-lock-screen">
            <i className="ri-lock-unlock-line align-middle me-2" />
            {props.t("Lock screen")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="ri-shut-down-line align-middle me-2 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
      <ChangePasswordModal
        isOpen={showChangePasswordModal}
        toggle={toggleChangePasswordModal}
        onPasswordChange={handlePasswordChange}
      />
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const success = state?.profile?.success;
  return { success };
};

export default withRouter(withTranslation()(ProfileMenu));
